import Configuration from "../config/index";
import * as api from "../http/apis/insurances";
import { InsuranceOptionsRequestBuilder } from "./insurance-options-request-builder";
import { InsuranceOptionsResponse } from "./insurance-options-response";
export const newInsuranceOptionsRequest = () => new InsuranceOptionsRequestBuilder();
export const getOptions = (request) => {
    InsuranceOptionsRequestBuilder.validateRequest(request);
    return api
        .find(request, Configuration.current())
        .then((response) => new InsuranceOptionsResponse(response));
};
